import React, { useState } from 'react'
import { Button } from '~/lib/ui/button'
import { useTranslation } from '~/hooks/useTranslation'

const UpgradeActions = ({ toggleOpen, platformName }) => {
  const { t } = useTranslation('UpgradeActions')
  const [confirm, setConfirm] = useState(false)

  return (
    <div className="flex flex-col gap-4">
      {!confirm ? (
        <div className="flex items-center gap-4">
          <Button onClick={() => setConfirm(true)}>{t('continue')}</Button>
          <Button variant="link" onClick={toggleOpen}>
            {t('not_now')}
          </Button>
        </div>
      ) : (
        <>
          <p className="!mb-0 text-lg font-medium">{t('are_you_sure')}</p>
          <p className="!mb-0 text-base">
            {t('upgrade_warning', { platformName: platformName })}
          </p>
          <div className="flex items-center gap-4">
            <Button className="!text-white">
              <a href="/op_next_upgrade" className="!text-white">
                {t('upgrade_now')}
              </a>
            </Button>
            <Button variant="link" onClick={toggleOpen}>
              {t('not_now')}
            </Button>
          </div>
        </>
      )}
    </div>
  )
}

export default UpgradeActions
